/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautions,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautionsFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautionsFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautionsToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautions';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse {
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    familySerialNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    familyNameKana?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    firstNameKana?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    customerNo?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    menuBasicInfo?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    customer?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    payMthdInfo?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautions>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    cautions?: Array<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautions>;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    canSubsidy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    canSubsidyRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    canCafePoint?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    orderSite?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    orderSubsidyFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    orderCafeFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    orderBenepoFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    orderPayFlag?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    subsidyRequiredAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    subsidyNoRequiredAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    benepoAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    cafeUsePoint?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    subTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    subsidyAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    billingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    canUsePoint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    doneApplySubsidy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    doneApplyCafe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse
     */
    contractCafe?: boolean;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familySerialNumber': !exists(json, 'familySerialNumber') ? undefined : json['familySerialNumber'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'familyNameKana': !exists(json, 'familyNameKana') ? undefined : json['familyNameKana'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'firstNameKana': !exists(json, 'firstNameKana') ? undefined : json['firstNameKana'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'menuBasicInfo': !exists(json, 'menuBasicInfo') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSON(json['menuBasicInfo']),
        'customer': !exists(json, 'customer') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSON(json['customer']),
        'payMthdInfo': !exists(json, 'payMthdInfo') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSON(json['payMthdInfo']),
        'cautions': !exists(json, 'cautions') ? undefined : ((json['cautions'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautionsFromJSON)),
        'canSubsidy': !exists(json, 'canSubsidy') ? undefined : json['canSubsidy'],
        'canSubsidyRequired': !exists(json, 'canSubsidyRequired') ? undefined : json['canSubsidyRequired'],
        'canCafePoint': !exists(json, 'canCafePoint') ? undefined : json['canCafePoint'],
        'orderSite': !exists(json, 'orderSite') ? undefined : json['orderSite'],
        'orderSubsidyFlag': !exists(json, 'orderSubsidyFlag') ? undefined : json['orderSubsidyFlag'],
        'orderCafeFlag': !exists(json, 'orderCafeFlag') ? undefined : json['orderCafeFlag'],
        'orderBenepoFlag': !exists(json, 'orderBenepoFlag') ? undefined : json['orderBenepoFlag'],
        'orderPayFlag': !exists(json, 'orderPayFlag') ? undefined : json['orderPayFlag'],
        'subsidyRequiredAmountTotal': !exists(json, 'subsidyRequiredAmountTotal') ? undefined : json['subsidyRequiredAmountTotal'],
        'subsidyNoRequiredAmountTotal': !exists(json, 'subsidyNoRequiredAmountTotal') ? undefined : json['subsidyNoRequiredAmountTotal'],
        'benepoAmountTotal': !exists(json, 'benepoAmountTotal') ? undefined : json['benepoAmountTotal'],
        'cafeUsePoint': !exists(json, 'cafeUsePoint') ? undefined : json['cafeUsePoint'],
        'subTotal': !exists(json, 'subTotal') ? undefined : json['subTotal'],
        'subsidyAmountTotal': !exists(json, 'subsidyAmountTotal') ? undefined : json['subsidyAmountTotal'],
        'billingAmount': !exists(json, 'billingAmount') ? undefined : json['billingAmount'],
        'canUsePoint': !exists(json, 'canUsePoint') ? undefined : json['canUsePoint'],
        'doneApplySubsidy': !exists(json, 'doneApplySubsidy') ? undefined : json['doneApplySubsidy'],
        'doneApplyCafe': !exists(json, 'doneApplyCafe') ? undefined : json['doneApplyCafe'],
        'contractCafe': !exists(json, 'contractCafe') ? undefined : json['contractCafe'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familySerialNumber': value.familySerialNumber,
        'familyName': value.familyName,
        'familyNameKana': value.familyNameKana,
        'firstName': value.firstName,
        'firstNameKana': value.firstNameKana,
        'age': value.age,
        'customerNo': value.customerNo,
        'menuBasicInfo': JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoToJSON(value.menuBasicInfo),
        'customer': JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerToJSON(value.customer),
        'payMthdInfo': JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoToJSON(value.payMthdInfo),
        'cautions': value.cautions === undefined ? undefined : ((value.cautions as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCautionsToJSON)),
        'canSubsidy': value.canSubsidy,
        'canSubsidyRequired': value.canSubsidyRequired,
        'canCafePoint': value.canCafePoint,
        'orderSite': value.orderSite,
        'orderSubsidyFlag': value.orderSubsidyFlag,
        'orderCafeFlag': value.orderCafeFlag,
        'orderBenepoFlag': value.orderBenepoFlag,
        'orderPayFlag': value.orderPayFlag,
        'subsidyRequiredAmountTotal': value.subsidyRequiredAmountTotal,
        'subsidyNoRequiredAmountTotal': value.subsidyNoRequiredAmountTotal,
        'benepoAmountTotal': value.benepoAmountTotal,
        'cafeUsePoint': value.cafeUsePoint,
        'subTotal': value.subTotal,
        'subsidyAmountTotal': value.subsidyAmountTotal,
        'billingAmount': value.billingAmount,
        'canUsePoint': value.canUsePoint,
        'doneApplySubsidy': value.doneApplySubsidy,
        'doneApplyCafe': value.doneApplyCafe,
        'contractCafe': value.contractCafe,
    };
}

